var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"delivery"},[(_vm.shipping)?_c('div',{staticClass:"shipping"},[_vm._v("\n        "+_vm._s(_vm.$shop.delivery.getDeliveryTitle(_vm.shipping))+" "),_c('br'),_vm._v(" "),_c('ShippingPriceCollapse',{attrs:{"delivery":_vm.shipping}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }